import './style.css';

import { getEvent } from 'components/graphql/queries';
import { getByCode } from 'components/graphql/queries/ticket';
import OnlyAdmin from 'components/guards/OnlyAdmin';
import OnlyLoggedIn from 'components/guards/OnlyLoggedIn';
import { closeModal, openModal } from 'components/modal/modules/dispatcher/methods';
import { AppConfig } from 'config/app';
import { getCookie } from 'lib/utils/cookie';
import { RouteTo } from 'lib/utils/routing';
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
	Collapse,
	DropdownItem,
	DropdownMenu,
	DropdownToggle,
	Input,
	Nav,
	Navbar,
	NavItem,
	NavLink,
	UncontrolledDropdown,
} from 'reactstrap';
import { fetchGraphQL } from 'services/graphql/GraphQL';
import UIDucks from 'stores/ducks/UI.duck';
import UIConfigDuck from 'stores/ducks/ui/UIConfig.duck';
import UserDucks from 'stores/ducks/User.duck';

import InviteUsersModal from './InviteUsersModal'

interface IAppBarProps {
	isLoggedIn?: boolean;
	dispatch?: any;
	isOpened?: boolean;
	isOpened2?: boolean;
	isVisible?: boolean;

	state?: any;
	user?: {
		name?: string;
		lastname?: string;
		email?: string;
		avatar?: string;
		stripeId?: string;
		id?: any;
		roles?: any;
	};
}
export class AppBar extends React.Component<IAppBarProps, { [label: string]: any }> {
	constructor(props) {
		super(props);
		this.renderUserItem = this.renderUserItem.bind(this);
		this.isLoggedIn = this.isLoggedIn.bind(this);
		this.toggleNavBarOverview = this.toggleNavBarOverview.bind(this);
		this.toggleNavBarEvents = this.toggleNavBarEvents.bind(this);
		this.toggleNavBar2 = this.toggleNavBar2.bind(this);
		this.state = {
			searchTerm: '',
			imgUrl: '',
			loading: false
		},
			this.getDashboardURL = this.getDashboardURL.bind(this);
		this.runSearch = this.runSearch.bind(this);
		this.setupPaymentsReminder = this.setupPaymentsReminder.bind(this);
		this.inviteUsers = this.inviteUsers.bind(this);
	}

	public toggleNavBarOverview(e?: any) {
		if (this.props.isOpened) {
			this.props.dispatch(UIDucks.setNavBar2(!this.props.isOpened2));
			return;
		}
		this.props.dispatch(UIDucks.setNavBar2(!this.props.isOpened2));
		this.props.dispatch(UIDucks.setAppBar(!this.props.isOpened));
	}

	public setupPaymentsReminder() {
		const content = <div className="sexyBlack">
			You must set up payments in order to start creating your own events and sell tickets.
			This is not required if you are selling or checking-in tickets for an event that you were added to as a team member.
			<hr />
			<div className="Seperate-Buttons">
				<button
					className='new-button-white-3'
					style={{
						border: 'none'
					}}
					onClick={e => closeModal()}
				>
					OK
				</button>
			</div>
		</div>
		openModal(content, "Set Up Payments")
	}


	public componentDidMount() {

		// White labelled logo should show up on
		// dashboard
		// sell
		// checkin
		// settings
		// uglyblock - public and private
		// receipt page
		// Istkt redirection
		// Shortened URLs

		// Whie labelled logo should not show up on
		// login
		// your events
		// oveview
		// settings

		// If public checkout page white label
		if (window.location.pathname.includes('/event/detail/')) {
			this.setState({ loading: true })
			const urlObjects = window.location.pathname.split('/');
			fetchGraphQL(getEvent(urlObjects[3]), undefined, {}).then(res => {
				this.setState({
					imgUrl: res.event.get.styling.bgImg,
					loading: false
				})
			})
			// If sell or dashboard or checkin page then white label
		} else if (window.location.pathname.includes('/manage/activate/digital')
			|| window.location.pathname.includes('/manage/events/detail')
			|| window.location.pathname.includes('/manage/events/checkin/')) {
			this.setState({ loading: true })
			const urlObjects = window.location.pathname.split('/');
			fetchGraphQL(getEvent(urlObjects[4]), undefined, {}).then(res => {
				this.setState({
					imgUrl: res.event.get.styling.bgImg,
					loading: false
				})
			})
			// If on the settings page then white label
		} else if (window.location.pathname.includes('/manage/events/edit/')) {
			this.setState({ loading: true });
			const urlObjects = window.location.pathname.split('/');
			const urlObjects2 = urlObjects[4].split('?')
			fetchGraphQL(getEvent(urlObjects2[0]), undefined, {}).then(res => {
				this.setState({
					imgUrl: res.event.get.styling.bgImg,
					loading: false
				})
			})
			// If on the receipt page then white label
		} else if (window.location.pathname.includes('/ticket/') && !window.location.pathname.includes('/event/')) {
			this.setState({ loading: true })
			const urlObjects = window.location.pathname.split('/')
			const ticketCode = urlObjects[2];
			fetchGraphQL(getByCode(),
				undefined,
				{ ticketCode }
			).then(result => {
				fetchGraphQL(getEvent(result.ticket.get.eventId), undefined, {}).then(res => {
					this.setState({
						imgUrl: res.event.get.styling.bgImg,
						loading: false
					})
				})
			})
			// If private checkout page white label
		} else if (window.location.pathname.includes('/ticket/') && window.location.pathname.includes('/event/')) {
			this.setState({ loading: true })
			const urlObjects = window.location.pathname.split('/')
			fetchGraphQL(getEvent(urlObjects[2]), undefined, {}).then(res => {
				this.setState({
					imgUrl: res.event.get.styling.bgImg,
					loading: false
				})
			})
			// Istkt redirection from any single tickets
		} else if (window.location.pathname.length === 6 && window.location.pathname !== "/login") {
			this.setState({ loading: true })
			const urlObjects = window.location.pathname.split('/')
			const ticketCode = urlObjects[1];
			fetchGraphQL(getByCode(),
				undefined,
				{ ticketCode }
			).then(result => {
				fetchGraphQL(getEvent(result.ticket.get.eventId), undefined, {}).then(res => {
					this.setState({
						imgUrl: res.event.get.styling.bgImg,
						loading: false
					})
				})
			})
			// What if the url is shortened, we need to retrieve the eventId first and then make change accordingly
		} else if (window.location.pathname.includes('/event-')) {
			this.setState({ loading: true })
			const urlObjects = window.location.pathname.split('-');
			fetchGraphQL(
				`
			query {
				url {
					getByCode(code:"${urlObjects[1]}") {
						eventId
						teamMap {
							userId
							index
						}
					}
				}
			}
			`
			).then(response => {
				fetchGraphQL(getEvent(response.url.getByCode.eventId), undefined, {}).then(res => {
					this.setState({
						imgUrl: res.event.get.styling.bgImg,
						loading: false
					})
				})
			})
		}
	}

	public getDashboardURL() {
		fetchGraphQL(`
		  query {
			user {
			  getStripeDashboardURL(stripeId:"${this.props.user!.stripeId}")
			}
		  }
		`).then(response => {
			window.location = response.user.getStripeDashboardURL
		})
	}

	public toggleNavBarEvents(e?: any) {

		if (!this.props.isOpened) {
			this.props.dispatch(UIDucks.setNavBar2(!this.props.isOpened2));
			return;
		}
		this.props.dispatch(UIDucks.setNavBar2(!this.props.isOpened2));
		this.props.dispatch(UIDucks.setAppBar(!this.props.isOpened));
	}
	public toggleNavBar2(e?: any) {
		this.props.dispatch(UIDucks.setNavBar2(!this.props.isOpened2));
	}

	public renderUserItem() {
		if (this.isLoggedIn()) {
			return (
				<UncontrolledDropdown nav={true} inNavbar={true}>
					<DropdownToggle nav={true} caret={true} className="new-button-blue-outline cut-text" style={{ lineHeight: '22.5px' }}>
						{this.props.user!.avatar ? (
							<img
								src={this.props.user!.avatar}
								style={{
									width: '28px',
									height: '28px',
									marginRight: '5px',
									borderRadius: '100px',
									fontStyle: 'bold',
									fontFamily: 'Rubik'
								}}
							/>
						) : null}
						{this.props.user!.name !== '' &&
							this.props.user!.lastname !== null
							? '   ' + this.props.user!.name + ' ' + this.props.user!.lastname
							: '   ' + this.props.user!.email}
					</DropdownToggle>
					<DropdownMenu right={true} style={{ borderRadius: '30px', textAlign: 'left' }}>
						<a href={AppConfig.hostUrl + "/settings"} style={{ textDecoration: 'none' }}>
							<DropdownItem onClick={this.toggleNavBarOverview} style={{ textAlign: 'left' }}>
								<b>
									Settings
								</b>
							</DropdownItem>
						</a>
						<Link to='/logout'>
							<DropdownItem onClick={this.toggleNavBarOverview} style={{ textAlign: 'left' }}>
								<b>
									Logout
								</b>
							</DropdownItem>
						</Link>
					</DropdownMenu>
				</UncontrolledDropdown>
			);
		}
		if (!getCookie("token")) {
			return (
				<NavItem>
					<Link to='/login'>
						<NavLink
							onClick={this.toggleNavBarOverview}
							className="sexyBlack"
						>
							LOGIN
						</NavLink>
					</Link>
				</NavItem>
			);
		}
	}

	public runSearch(e: any) {
		if (e.target.value === '') {
			this.props.dispatch(UIDucks.search({ searchTerm: '', resultFound: false, result: [''] }))
			return;
		}

		this.props.dispatch(UIDucks.search({ searchTerm: e.target.value }));
		fetchGraphQL(
			`
				{
				  event {
					search(searchTerm:"${e.target.value}") 
				  }
				}
		  `,
			undefined
		).then(result => {
			if (result.event.search.length !== 0) {
				this.props.dispatch(UIDucks.search({ resultFound: true, result: result.event.search }))
			} else {
				this.props.dispatch(UIDucks.search({ resultFound: true, result: [''] }))
			}
		})


	}

	public inviteUsers() {
		openModal(<InviteUsersModal />, "Invite New Users")
	}

	public render() {
		if (!this.props.isVisible) {
			return null;
		}

		if (window.location.pathname === '/login'
			|| window.location.pathname === '/login/'
			|| window.location.pathname === '/logout'
			|| window.location.pathname === "/"
			|| window.location.pathname.includes('/setup/')
			|| (window.location.pathname === '/manage/events' && (this.props.user === undefined || this.props.user.id === undefined || this.props.user.id! === ''))) {
			return null;
		}
		
		const content2 =
			<NavItem>
				<a href={AppConfig.hostUrl + "/manage/events"}>
					<div className={
						window.location.pathname.includes('/manage') &&
							!window.location.pathname.includes('create')
							? "new-button-outline-selected" : "new-button-outline"}>
						Your Events
					</div>
				</a>
			</NavItem>

		const content3 =
			<NavItem>
				<div className="new-button-outline" style={{ cursor: 'pointer' }} onClick={this.inviteUsers}>
					Invite Users
				</div>
			</NavItem>

		let searchBar = <div />
		if (window.location.pathname === '/manage/events') {
			searchBar = <Input
				type="text"
				name="search"
				id="search"
				placeholder="🔍"
				style={{ maxWidth: '225px' }}
				value={this.props.state.UI.searchTerm}
				onChange={(e) => this.runSearch(e)}
			/>
		}

		let logo = require('./Dark-logo-copy.png');
		if (this.state.imgUrl !== null
			&& this.state.imgUrl !== ''
			&& window.location.pathname !== '/manage/events'
			&& !window.location.pathname.includes('/login')
			&& !window.location.pathname.includes('/overview')
			&& !window.location.pathname.includes('/settings')
			&& !window.location.pathname.includes('/setup/')
		) {
			logo = this.state.imgUrl
		}

		return (
			<div key={window.location.pathname} style={{ backgroundColor: '#F8F8F8', borderBottom: '1px solid #F1F1F1', backdropFilter: 'blur(15px)' }}>
				<Navbar className='sticky-top' expand='xl'>
					<div className="container">
						{
							this.state.loading ? null :
								<a href={
									this.props.user === undefined
										|| this.props.user.id === undefined
										|| this.props.user.id === null
										|| this.props.user.id === ""
										? AppConfig.hostUrl + '/' : AppConfig.hostUrl + '/manage/events'
								} className="navbar-brand">
									<img src={logo} height="80px" style={{ paddingRight: '10px' }} />
								</a>
						}
						{
							window.location.pathname === '/manage/events' ? searchBar : null
						}
						{
							this.state.loading ? null :
								<button
									className={
										this.props.isOpened2
											? 'navbar-toggler animated-burger navbar-toggler-right menu-button'
											: 'navbar-toggler animated-burger navbar-toggler-right collapsed menu-button'
									}
									type='button'
									data-toggle='collapse'
									data-target='#collapsingNavbar'
									onClick={this.toggleNavBar2}
								>
									<span />
									<span />
									<span />
								</button>
						}
						<Collapse isOpen={this.props.isOpened2} navbar={true} style={{ width: 'auto' }}>
							<div className="big-split-1200" style={{ float: 'right', paddingLeft: '15px' }}>
								<Nav className='ml-auto' navbar={true} style={{ paddingTop: '0 auto', paddingBottom: '0 auto', paddingight: '0 auto', float: 'right' }}>
									<OnlyLoggedIn>
										<div style={{ width: '160px', textAlign: 'center', paddingTop: '0 auto', paddingBottom: '0 auto', marginRight: '7px' }}>
											<NavItem style={{ lineHeight: '38px' }}>
												<a href={AppConfig.hostUrl + "/manage/events-create"}>
													<div className={window.location.pathname === '/manage/events-create' ? "new-button-outline-selected" : "new-button-outline"}>
														Create Event
													</div>
												</a>
											</NavItem>
										</div>
										{
											this.props.user!.id === '5d3a0a1f7634d34b1a554849' ? null :
												<div style={{ width: '160px', textAlign: 'center', paddingTop: '0 auto', paddingBottom: '0 auto', marginRight: '7px' }}>
													<NavItem style={{ width: '100%' }}>
														{
															this.props.user!.stripeId !== undefined && this.props.user!.stripeId !== null ?
																<div style={{ textAlign: 'center', cursor: 'pointer' }} className="new-button-outline" onClick={this.getDashboardURL}>
																	Payments
																</div>
																:
																<a href={RouteTo.paymentSetup(this.props.user!.id)} style={{ textDecoration: 'none' }}>
																	<div style={{ cursor: 'pointer', textAlign: 'center' }} className="new-button-outline">
																		Set Up Payments
																	</div>
																</a>
														}
													</NavItem>
												</div>
										}
										{/* <div style={{ width: '140px', textAlign: 'center', paddingTop: '0 auto', paddingBottom: '0 auto', marginRight: '7px' }}>
											{content1}</div> */}
										<div style={{
											width: '160px', textAlign: 'center', paddingTop: '0 auto', paddingBottom: '0 auto', marginRight: '7px'
										}}>{content2}</div>
										<OnlyAdmin>
											< div style={{ width: '160px', textAlign: 'center', paddingTop: '0 auto', paddingBottom: '0 auto', marginRight: '7px' }}>{content3}</div>
										</OnlyAdmin>
									</OnlyLoggedIn>
									<div style={{ width: '160px', textAlign: 'center', paddingTop: '0 auto', paddingBottom: '0 auto', paddingLeft: '5px' }}>
										{this.renderUserItem()}
									</div>
								</Nav>
							</div>
							<div className="small-split-1200" style={{ float: 'right' }}>
								<Nav className='ml-auto' navbar={true} style={{ paddingTop: '0 auto', paddingBottom: '0 auto', paddingight: '0 auto', float: 'right' }}>
									<OnlyLoggedIn>
										<div>
											<div style={{ width: '150px', textAlign: 'right', paddingTop: '0 auto', paddingBottom: '0 auto' }}>
												<NavItem>
													<a href={AppConfig.hostUrl + "/manage/events-create"}>
														<div>
															<NavLink>Create Event</NavLink>
														</div>
													</a>
												</NavItem>
											</div>
										</div>
										{
											this.props.user!.id === '5d3a0a1f7634d34b1a554849' ? null :
												<div style={{ width: '150px', textAlign: 'right', paddingTop: '0 auto', paddingBottom: '0 auto' }}>
													<NavItem>
														{
															this.props.user!.stripeId !== undefined && this.props.user!.stripeId !== null ?
																<div className="sexyBlack">
																	<NavLink onClick={this.getDashboardURL}>
																		Payments
															</NavLink>
																</div>
																:
																<a href={RouteTo.paymentSetup(this.props.user!.id)} style={{ textDecoration: 'none' }}>
																	<div className="sexyBlack" style={{ paddingTop: '0 auto', paddingBottom: '0 auto', lineHeight: '40px' }}>
																		Set Up Payments
															</div>
																</a>

														}
													</NavItem>
												</div>
										}
										{/* <div style={{ width: '150px', textAlign: 'right', paddingTop: '0 auto', paddingBottom: '0 auto' }}>
											<a href={AppConfig.hostUrl + "/dashboard/overview"}>
												<div className="sexyBlack" style={{ paddingTop: '0 auto', paddingBottom: '0 auto', lineHeight: '40px' }}>
													Overview
												</div>
											</a>
										</div> */}
										<div style={{ width: '150px', textAlign: 'right', paddingTop: '0 auto', paddingBottom: '0 auto' }}>
											<a href={AppConfig.hostUrl + "/manage/events"}>
												<div className="sexyBlack" style={{ paddingTop: '0 auto', paddingBottom: '0 auto', lineHeight: '40px' }}>
													Your Events
												</div>
											</a>
										</div>
										<OnlyAdmin>
											<div style={{ width: '150px', textAlign: 'right', paddingTop: '0 auto', paddingBottom: '0 auto' }}>
												<div
													onClick={this.inviteUsers}
													className="sexyBlack" style={{ paddingTop: '0 auto', paddingBottom: '0 auto', lineHeight: '40px' }}>
													Invite Users
												</div>
											</div>
										</OnlyAdmin>
									</OnlyLoggedIn>
									<div style={{ width: '150px', textAlign: 'right', paddingTop: '0 auto', paddingBottom: '0 auto' }}>
										{this.renderUserItem()}
										{
											this.props.isOpened2 ?
												<div><br /><br /></div> :
												null
										}
									</div>
								</Nav>
							</div>
							<p />
						</Collapse>
					</div>
				</Navbar>
			</div >
		);
	}

	private isLoggedIn(): boolean {
		return this.props.isLoggedIn === true;
	}
}

const mapStateToProps = state => ({
	isLoggedIn: UserDucks.isAuthenticated(state),
	isOpened: UIDucks.getIsAppBarOpen(state),
	isOpened2: UIDucks.getIsNavBarOpen2(state),
	state: UIDucks.getState(state),
	user: UserDucks.getUser(state),
	isVisible: UIConfigDuck.isAppBarVisible(state),
});

export default connect(mapStateToProps)(AppBar);



// WEBPACK FOOTER //
// ./src/components/common/controls/navbar/AppBar.tsx